<template>
  <b-modal v-if="usersPop" v-model="active" :title="title" centered hide-footer size="md">
    <div class="mt-3 px-4">
      <b-row v-for="(user, index) in formatedUsers" :key="index" class="mb-2 align-items-center">
        <b-col cols="2"></b-col>
        <b-col cols="2">
          <h-e-profile-default :first-name="user.firstName" :last-name="user.lastName" size="sm"></h-e-profile-default>
        </b-col>
        <b-col cols="8">
          <div class="ml-5">{{ user.firstName }} {{ user.lastName }}</div>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
import { APIRequest, FunctionHelpers } from '@/node-sdk'

export default {
  name: 'user',

  props: {
    value: Array,
    title: {
      type: String,
      required: true,
    },
    users: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      usersPop: [],
      active: false,
      userUrl: process.env.VUE_APP_API,
      assignedUsers: this.value,
      formatedUsers: [],
    }
  },

  watch: {
    searchUsers: function () {
      this.formatSearchUsers()
    },

    value: async function () {
      this.assignedUsers = this.value
      this.formatAssignedUsers()
    },
  },

  async mounted() {
    if (this.users.length === 0) {
      await this.getUsers()
    }
  },

  methods: {
    manageUserPop() {
      this.active = !this.active
    },

    async getUsers() {
      this.usersPop = await APIRequest.get_with_request(process.env.VUE_APP_API, 'users', '')
      this.usersPop = this.usersPop[0]
      this.formatAssignedUsers()
    },

    formatAssignedUsers() {
      this.formatedUsers = []
      this.formatedUsers = FunctionHelpers.formatUsers(this.usersPop, this.assignedUsers)
    },
  },
}
</script>

<style scoped></style>
